/**
 * Join path parts together and returns the resulting dot notation
 *
 * @param {(string | number)[]} args
 *
 * @return {string}
 */
export var joinPaths = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return (args.filter(function (string) { return string !== ''; }).join('.'));
};
//# sourceMappingURL=joinPaths.js.map